import React, { Component } from 'react';
import Lottie from 'react-lottie';

import styles from "components/PlayerStyles.module.scss";


export default class Player extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentWillReceiveProps(nextProps) {
        
    }


    render() {
        return (
            <div id={`player-${this.props.player.id}`} className={`${styles.player} ${this.props.left ? "" : styles.reverse} ${this.props.player.showPlayer && !this.props.player.spectating && styles.show}`}>
                <div className={`${styles.spotlight}`} />
                <div id={`potato-${this.props.player.id}`} className={`${styles.potato}`}>
                    <img style={{ width: "100%", height: "100%", padding: "5%", objectFit: "contain" , filter: this.props.left ? "drop-shadow(-2vh 1vh 0px #000)" : "drop-shadow(2vh 1vh 0px #000)" }} src={this.props.player.avatar} alt="avatar" />
                    
                </div>
                <div className={`${styles.textSection}`}>
                    <div className={`${styles.name}`}>{this.props.player.name}</div>
                    <div className={`${styles.points}`}>{this.props.player.chameleonData.score} Points</div>
                </div>
            </div>
        )
    }
}